<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button class="filter-item" type="primary" @click="handleCreate"
        >新增</el-button
      >
      <el-input
        v-model="listQuery.name"
        placeholder="请输入教师姓名"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.school_id"
        placeholder="请选择学校"
        clearable
        style="width: 250px"
        class="filter-item"
      >
        <el-option
          v-for="item in school_list"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-select
        v-model="listQuery.is_normal"
        placeholder="状态"
        clearable
        style="width: 150px"
        class="filter-item"
      >
        <el-option label="正常" :value="1" />
        <el-option label="冻结" :value="0" />
      </el-select>
      <el-button class="filter-item" type="primary" @click="handleFilter"
        >搜索</el-button
      >
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column label="ID" width="95" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="教师名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column label="性别" min-width="110" align="center">
        <template slot-scope="scope">
          {{
            scope.row.gender == 1
              ? "男"
              : scope.row.gender == 2
              ? "女"
              : "未设置"
          }}
        </template>
      </el-table-column>
      <el-table-column label="账号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.account }}
        </template>
      </el-table-column>
      <el-table-column label="联系电话" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.phone }}
        </template>
      </el-table-column>
      <el-table-column label="邮箱" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.email }}
        </template>
      </el-table-column>
      <el-table-column label="简介" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.synopsis }}
        </template>
      </el-table-column>
      <el-table-column label="学校安排" min-width="150" align="center">
        <template slot-scope="scope">
          <el-tag
            style="margin-bottom: 10px"
            v-for="(v, i) in scope.row.school_course_distribution"
            :key="i"
          >
            {{ v.school.name }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="在职状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status == 1">在职</el-tag>
          <el-tag type="primary" v-else-if="scope.row.status == 2">兼职</el-tag>
          <el-tag type="danger" v-else>离职</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.is_normal">正常</el-tag>
          <el-tag type="danger" v-else>冻结</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="280"
        align="center"
        class-name="small-padding fixed-width"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleUpdate(scope.row)"
            >修改</el-button
          >
          <!-- <el-button size="mini" type="danger" @click="allot(scope.row)">学校分配</el-button> -->
          <el-button size="mini" type="primary" @click="initOne(scope.row.id)"
            >初始化密码</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleForbid(scope.row.id, '冻结')"
            v-if="scope.row.is_normal"
            >冻结</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="handleForbid(scope.row.id, '解冻')"
            v-else
            >解冻</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="handleRecord(scope.row.id)"
            >上课记录</el-button
          >
          <el-button
            size="mini"
            type="primary"
            @click="handleClass(scope.row.id)"
            >查看课表</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      :title="textMap[dialogStatus]"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :rules="rules" :model="form" label-width="130px">
        <el-form-item label="请输入教师名称:" prop="name">
          <el-input type="text" v-model="form.name" clearable />
        </el-form-item>
        <el-form-item label="请选择教师性别:" prop="gender">
          <el-select
            v-model="form.gender"
            placeholder="请选择教师性别"
            clearable
          >
            <el-option label="男" :value="1" />
            <el-option label="女" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="请输入教师账号:" prop="account">
          <el-input type="text" v-model="form.account" clearable />
        </el-form-item>
        <el-form-item label="请输入教师邮箱:" prop="email">
          <el-input type="text" v-model="form.email" clearable />
        </el-form-item>
        <el-form-item label="请输入教师简介:" prop="synopsis">
          <el-input type="text" v-model="form.synopsis" clearable />
        </el-form-item>
        <el-form-item label="请输入联系电话:" prop="phone">
          <el-input type="text" v-model="form.phone" clearable />
        </el-form-item>
        <el-form-item label="在职状态" prop="status">
          <el-select
            v-model="form.status"
            placeholder="请选在职状态"
            style="width: 150px"
            class="filter-item"
          >
            <el-option label="在职" :value="1" />
            <el-option label="兼职" :value="2" />
            <el-option label="离职" :value="3" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  data() {
    return {
      list: [],
      total: null,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        name: "",
        school: "",
        is_on: "",
      },
      dialogFormVisible: false,
      dialogStatus: "",
      textMap: {
        update: "修改",
        create: "新增",
      },
      form: {
        id: "",
        name: "",
        account: "",
        phone: "",
        status: 1,
      },
      rules: {
        name: [
          { required: true, message: "教师名称不能为空", trigger: "change" },
        ],
        account: [
          { required: true, message: "教师账号不能为空", trigger: "change" },
        ],
        email: [
          { required: true, message: "教师邮箱不能为空", trigger: "change" },
        ],
        synopsis: [
          { required: true, message: "教师简介不能为空", trigger: "change" },
        ],
        phone: [
          { required: true, message: "联系电话不能为空", trigger: "change" },
        ],
      },
      btnLoading: false,
      school_list: [],
    };
  },
  created() {
    this.getList();
    this.getSchoolList()
  },
  watch: {
    dialogFormVisible(val) {
      if (val) this.getSchoolList();
    },
  },
  methods: {
    handleClass(id) {
      this.$router.push(`/teacher/class_schedule?teacher_id=${id}`);
    },
    handleRecord(id) {
      this.$router.push(`/teacher/record?teacher_id=${id}`);
    },
    //  获取学校列表
    getSchoolList() {
      request({
        url: "/api/backend/school/list",
        method: "get",
        params: { limit: 9999999 },
      }).then((response) => {
        this.school_list = response.data.data;
      });
    },
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/teacher/eSportslist",
        method: "get",
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
        this.$forceUpdate(); //强制更新
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    resetForm() {
      this.form = {
        id: "",
        name: "",
        account: "",
        phone: "",
        status: 1,
      };
      this.btnLoading = false;
    },
    handleCreate() {
      this.resetForm();
      this.dialogStatus = "create";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    handleUpdate(row) {
      this.resetForm();
      this.form = Object.assign({}, row);
      this.dialogStatus = "update";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    saveData() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          request({
            url: "/api/backend/teacher/eSportsStore",
            method: "post",
            data: this.form,
          })
            .then((response) => {
              this.btnLoading = false;
              this.dialogFormVisible = false;
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.getList();
            })
            .catch((err) => {
              this.btnLoading = false;
            });
        }
      });
    },
    //上下架
    handleStatus(val, text) {
      this.$confirm("此操作将" + text + "该课程类型, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/course/categoryUpDown",
            method: "post",
            data: { id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功",
            });
          });
        })
        .catch(() => {});
    },
    // 删除
    delOne(id) {
      this.$confirm("此操作将删除该教师, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/school/teacherDel",
            method: "post",
            data: { id },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功",
            });
          });
        })
        .catch(() => {});
    },
    // 初始化
    initOne(id) {
      this.$confirm("此操作将初始化该账号密码, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/teacher/initPassword",
            method: "post",
            data: { id },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功",
            });
          });
        })
        .catch(() => {});
    },
    //冻结
    handleForbid(val, text) {
      this.$confirm("此操作将" + text + "该用户, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/teacher/changeNormal",
            method: "post",
            data: { id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功",
            });
          });
        })
        .catch(() => {});
    },
    //分配
    allot(data) {
      this.$router.push(
        `/teacher/teacherAllot?id=${data.id}&name=${data.name}`
      );
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
